import { FormSettingsType } from '../components/Form';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  duration: yup.string()
    .min(0, 'ALERT_DURATION_MINLENGTH')
    .max(2, 'ALERT_DURATION_MAXLENGTH')
    // .matches(/^[0-9]*$/, 'ALERT_DURATION_INVALID')
    .required('ALERT_DURATION_REQUIRED'),
  name: yup.string()
    .min(3, 'ALERT_NAME_MINLENGTH')
    .max(30, 'ALERT_NAME_MAXLENGTH')
    // .matches(/^[a-zA-Z0-9]*$/, 'ALERT_NAME_INVALID')
    .required('ALERT_NAME_REQUIRED'),
  text: yup.string()
    .min(3, 'ALERT_TEXT_MINLENGTH')
    .max(150, 'ALERT_TEXT_MAXLENGTH')
    // .matches(/^[a-zA-Z0-9]*$/, 'ALERT_TEXT_INVALID')
    .required('ALERT_TEXT_REQUIRED')
})

export const AlertSearchForm: FormSettingsType = {
  submitOnKeyEnter: true,
  fields: [
    {
      type: 'search',
      name: 'searchTerm',
      placeholder: 'form.placeholders.alertsSearch',
      addorn: {
        rightIcon: 'search',
      },
    },
  ],
};

export const AlertForm: FormSettingsType = {
  validationSchema: validationSchema,
  fields: [
    {
      type: 'text',
      className: 'hidden',
      name: 'id',
      label: '',
    },
    {
      type: 'text',
      name: 'name',
      label: 'form.labels.alerts.name',
      maxLength: 30,
    },
    {
      type: 'text',
      name: 'text',
      label: 'form.labels.alerts.text',
      maxLength: 150,
    },
    {
      type: 'masked',
      name: 'duration',
      label: 'form.labels.alerts.duration',
      mask: [
        /[1-9]/,
        /\d/,
      ],      
    },
    {
      type: 'upload',
      name: 'imgData',
      label: 'form.labels.alerts.image',
      placeholder: 'form.placeholders.photo',
    },
  ],
};

export const AlertEditForm: FormSettingsType = {
  validationSchema: validationSchema,
  fields: [
    {
      type: 'text',
      className: 'hidden',
      name: 'id',
      label: '',
    },
    {
      type: 'text',
      name: 'name',
      label: 'form.labels.alerts.name',
    },
    {
      type: 'text',
      name: 'text',
      label: 'form.labels.alerts.text',
    },
    {
      type: 'masked',
      name: 'duration',
      label: 'form.labels.alerts.duration',
      mask: [
        /[1-9]/,
        /\d/,
      ],
    },
    // {
    //   type: 'uploadperbutton',
    //   name: 'imgData',
    //   label: 'form.labels.alerts.image',
    //   placeholder: 'form.placeholders.photo',
    // },
  ],
}




